import { useHyphenate } from '../../hooks/useHyphenate';
import './BlogPostContent.css';

const TextSection = ({ section, hyphenate }) => (
  <p className="blog-section-text">{hyphenate(section.text)}</p>
);

const BulletsSection = ({ section, hyphenate }) => (
  <ul className="blog-section-bullets">
    {section.bullets.map((bullet, idx) => (
      <li key={idx}>{hyphenate(bullet)}</li>
    ))}
  </ul>
);

const SECTION_RENDERERS = {
  text: TextSection,
  bullets: BulletsSection,
};

const BlogPostContent = ({ sections }) => {
  const hyphenate = useHyphenate();

  return (
    <div className="blog-post-content">
      {sections.map((section, idx) => {
        const Renderer = SECTION_RENDERERS[section.type];
        if (!Renderer) return null;
        return (
          <section key={idx} className="blog-section">
            {section.heading && <h2 className="blog-section-heading">{hyphenate(section.heading)}</h2>}
            <Renderer section={section} hyphenate={hyphenate} />
          </section>
        );
      })}
    </div>
  );
};

export default BlogPostContent;
